import moment from "moment-timezone";
import {
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { MOMENT_SETTING } from "../../../constant";

const MultiInquiryShowPopup = (props) => {
  const { model, setModel, detail } = props;

  return (
    <Modal size="lg" isOpen={model} toggle={() => setModel(!model)}>
      <ModalHeader toggle={() => setModel(!model)}>Career Inquary</ModalHeader>
      <ModalBody>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody style={{ padding: "0" }}>
                <Card>
                  <div className="table-responsive">
                    <Table>
                      <tbody>
                        <tr>
                          <th scope="row">{"Date & Time"}</th>
                          <td>
                            {detail?.createdAt &&
                              moment
                                .utc(detail?.createdAt)
                                .format(MOMENT_SETTING.FORMATE_WITH_TIME)}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{"Name"}</th>
                          <td>{detail?.name ? detail?.name : "-"}</td>
                        </tr>
                        {detail?.email && (
                          <tr>
                            <th scope="row">{"Email"}</th>
                            <td>{detail?.email ? detail?.email : "-"}</td>
                          </tr>
                        )}

                        {detail?.phone && (
                          <tr>
                            <th scope="row">{"Contact"}</th>
                            <td>
                              {detail?.phone
                                ? detail?.dialCode + " " + detail?.phone
                                : "-"}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <th scope="row">{"Address"}</th>
                          <td>
                            {`${detail.address ? detail.address + "," : ""}${
                              detail?.city ? detail?.city + "," : ""
                            }${detail?.state ? detail?.state + "," : ""}${
                              detail?.country ? detail?.country + " " : ""
                            }${
                              detail?.postcode ? "- " + detail?.postcode : ""
                            }`}
                          </td>
                        </tr>
                        {detail?.subject && (
                          <tr>
                            <th scope="row">{"Topic"}</th>
                            <td>{detail?.subject}</td>
                          </tr>
                        )}

                        {detail?.message && (
                          <tr>
                            <th scope="row">{"Message"}</th>
                            <td>
                              <div style={{ width: "27vw" }}>
                                {detail?.message ? detail?.message : "-"}
                              </div>
                            </td>
                          </tr>
                        )}

                        {detail?.upload_resume && (
                          <tr>
                            <th scope="row">{"Upload File"}</th>
                            <td>
                              <div style={{ width: "27vw" }}>
                                <a href={detail?.upload_resume} target="_blank">
                                  Document
                                </a>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default MultiInquiryShowPopup;
